import React from 'react';
import PropTypes from 'prop-types';
import './SlateToggleGroup.css';

var SlateToggleGroup = function(props) {
  var options = props.options;
  var value = props.value;
  var onChange = props.onChange;
  var label = props.label;
  var disabled = props.disabled;

  return (
    <div className="slate-toggle-group">
      {label && <div className="slate-toggle-group-label">{label}</div>}
      <div className="slate-toggle-group-buttons">
        {options.map(function(option) {
          var isActive = value === option.value;
          var className = 'slate-toggle-btn';
          if (isActive) {
            className = className + ' slate-toggle-btn--active';
          }
          if (disabled) {
            className = className + ' slate-toggle-btn--disabled';
          }
          return (
            <button
              key={option.value}
              type="button"
              className={className}
              onClick={function() { onChange(option.value); }}
              disabled={disabled}
            >
              {option.label}
            </button>
          );
        })}
      </div>
    </div>
  );
};

SlateToggleGroup.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  disabled: PropTypes.bool,
};

export default SlateToggleGroup;
